export default "__VITE_ASSET__Y6mgbxB8__"